<template>
    <div
            class="property-details-footer"
            v-if="data"
    >
        <b-row>
            <template
                    v-for="(info, index) in data"
            >
                <b-col
                        :key="index"
                        v-if="info.asset"
                        cols="12"
                        md="2"
                        class="d-flex align-items-center justify-content-start logo-container"
                >
                    <b-img
                            :src="info.asset.url"
                            class="w-100"
                    />
                </b-col>
                <b-col
                        v-if="info.text"
                        :key="index"
                        cols="12"
                        :md="info.asset ? 10 : 12"
                        class="d-flex align-items-center"
                >
                    <div
                            class="footer-line"
                            v-html="info.text"
                    />
                </b-col>
            </template>
        </b-row>
    </div>
</template>
<script>
    import './PropertyDetailsFooter.scss';

    export default {
        name: 'PropertyDetailsFooter',
        props: {
            mlsCompliance: {
                type: [Object, Boolean],
                required: true,
            },
            displayFootnote: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                data: []
            };
        },
        methods: {
            prepareData() {
                const mlsData = this.mlsCompliance?.data?.data;

                const listOfData = [
                    'copyright',
                    'disclaimer',
                    'eula',
                    'dmca',
                ];

                listOfData.forEach(value => {
                    if (mlsData?.page[value]) {
                        this.data.push({
                            text: mlsData?.page[value]?.lexicon,
                            asset: mlsData?.page[value]?.asset
                        });
                    }
                });

                if (mlsData?.details?.footnotes) {
                    this.data.push({
                        text: mlsData?.details?.footnotes?.lexicon,
                        asset: mlsData?.details?.footnotes?.asset
                    });
                }
            },
        },
        beforeMount() {
            this.prepareData();
        }
    };
</script>
